module.exports = __webpack_public_path__ + "static/media/z.a7b9b58d.png";